var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: _vm.width })},[_c('div',{staticClass:"image-container"},[_c('img',{staticClass:"image-asspec-ratio",attrs:{"loading":"lazy","aria-label":_vm.areaLabel,"src":_vm.url + _vm.imageName,"alt":_vm.imageName}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }